(module => {
  unsafe.$inject = ['$sce'];
  function unsafe($sce) {
    return $sce.trustAsHtml;
  }
  module.filter('unsafe', unsafe);
})(angular.module('postCenterWebClientApp'));
